module.exports = __webpack_public_path__ + "img/landline.e3244472.png";